import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import hexOpacity from '@deprecated-ui/utils/hexOpacity';
import { ModalConfirm } from './styled';

interface ModalFailedPostProps {
  onSubmit: (val: any) => void;
  onCancel: () => void;
  isLoading: boolean;
  [key: string]: any;
}

function ModalFailedPost({
  onSubmit,
  onCancel,
  isLoading,
  ...props
}: ModalFailedPostProps) {
  return (
    <ModalConfirm
      onCancel={onCancel}
      centered
      closable={false}
      width={400}
      zIndex={1200}
      title={
        <Text
          size="20px"
          height="40px"
          family="bold"
          // @ts-expect-error
          pt="20px"
          pl="20px"
          pr="20px"
        >
          Gagal Memposting
        </Text>
      }
      footer={
        // @ts-expect-error
        <Flex pb="20px" px="20px" justify="flex-end" align="flex-end">
          <Button
            key="cancel"
            height="40px"
            type="borderless"
            color="primary"
            // @ts-expect-error
            mx="9px"
            onClick={onCancel}
          >
            Batal
          </Button>
          <Button
            key="confirm"
            type="primary"
            height="40px"
            width="126px"
            onClick={onSubmit}
            loading={isLoading}
          >
            Coba Lagi
          </Button>
        </Flex>
      }
      maskStyle={{ backgroundColor: `${color.black}${hexOpacity(80)}` }}
      {...props}
    >
      {/* @ts-expect-error */}
      <Text pt="10px" pb="20px" px="20px">
        Postingan kamu gagal terkirim. Coba lagi untuk mengirim ulang.
      </Text>
    </ModalConfirm>
  );
}

export default ModalFailedPost;
